import React, { Component } from 'react';
import autobind from 'class-autobind';

import BaseModal from 'zoomforth_component_lib/base_modal.jsx';
import SiteListModalUI from './site_list_modal_ui.jsx';

class ReplaceAssetModal extends Component {

  constructor(props) {
    super(props);
    autobind(this);

    this.state = {};
  }

  render() {
    const { onClose } = this.props;

    return (
      <BaseModal
        style={{ padding: '0', width: '464px', height: '580px' }}
        onRequestClose={onClose}
      >
        <SiteListModalUI {...{ ...this.props }} />;
      </BaseModal>
    );
  }
}


export default ReplaceAssetModal;